import { FETCH_EDIT_USER_INFO_FORM_INITIAL } from '../actions'

export default function (state = {}, action) {
    switch (action.type) {
        case FETCH_EDIT_USER_INFO_FORM_INITIAL:
            let initial_value = action.payload
            let address = action.payload.address
            if (address) {
                initial_value = { ...initial_value, ...address['address1'] }
            }
            return initial_value
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/reducers/edit_user_info_form_initial_reducer.js